import { DealerTabSection, DealerTabState } from "@/components/DealerDetail/DealerTabState";
import { useApi } from "@/hooks/useApi";
import { dealerService } from "@/services/DealerService";
import { DealerRate } from "@/types/dealer";

const formatPercentage = (value: number): string =>
  `${value.toLocaleString("en-GB", { maximumFractionDigits: 2 })}%`;

const sortByFinanceCompany = (rates: DealerRate[]): DealerRate[] =>
  [...rates].sort((a, b) => (a.financeCompany ?? "").localeCompare(b.financeCompany ?? ""));

export function RatesTab({ dealerId }: { dealerId: number }) {
  const { data, loading, error } = useApi((signal) => dealerService.getDealerRates(dealerId, signal), [dealerId]);

  return (
    <DealerTabState data={data} loading={loading} error={error} label="rates" emptyMessage="No rates found for this dealer.">
      {(rates) => (
        <DealerTabSection title="Rates" count={rates.length}>
          <div className="overflow-x-auto">
            <table className="w-full min-w-max text-sm">
              <thead>
                <tr className="bg-muted/40 border-b text-left">
                  <th className="p-3 font-medium">Finance company</th>
                  <th className="p-3 text-right font-medium">Rate</th>
                  <th className="p-3 text-right font-medium">Commission</th>
                </tr>
              </thead>
              <tbody>
                {sortByFinanceCompany(rates).map((rate) => (
                  <tr key={rate.rateId} className="border-b last:border-b-0">
                    <td className="p-3 font-semibold">{rate.financeCompany?.trim() || "-"}</td>
                    <td className="p-3 text-right">{formatPercentage(rate.rate)}</td>
                    <td className="p-3 text-right">{rate.commission === null ? "-" : formatPercentage(rate.commission)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </DealerTabSection>
      )}
    </DealerTabState>
  );
}
